module.exports = __webpack_public_path__ + "img/brume-hero_mob.d1739f8.webp";